import React, { FC, useState } from "react";
import { Button, Input, message, Modal, Table } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { useShipmentDetailModel } from "../shipmentDetailModel";
import { IShipmentMaterial } from "@/views/shipment/shimentTypes";
import { formatNum } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { enquiryService } from "@/views/inquires/enquiry/enquiryService";

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const {
        editList, getcurrencySymbol, updateList,editFormVal
    } = useShipmentDetailModel(({ editList }) => [editList]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const columns = [
        {
            title: '序号',
            width: 45,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '商品编码',
            width: 160,
            dataIndex: 'materialCode',
        }, {
            title: '商品名称',
            width: 160,
            dataIndex: 'materialName',
        }, {
            title: '商品名称-英文',
            width: 160,
            dataIndex: 'materialEname',
        }, {
            title: '商品类型',
            width: 160,
            dataIndex: 'typeName',
        }, {
            title: '*销售数量',
            width: 160,
            dataIndex: 'num',
        }, {
            title: '销售单价',
            width: 160,
            dataIndex: 'price',
            render: (text: any) => text === "null" ? "" : `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        }, {
            title: '销售金额',
            width: 160,
            dataIndex: 'amount',
            render: (text: any) => `${getcurrencySymbol(mode)} ${formatNum(text)}`,
        }, {
            title: '规格',
            width: 160,
            dataIndex: 'model',
        }, {
            title: '净重(KG)',
            width: 120,
            dataIndex: 'netWeight',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl'
        }, {
            title: '毛重(KG)',
            width: 120,
            dataIndex: 'grossWeight',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl'
        }, {
            title: '规格',
            width: 160,
            dataIndex: 'model',
        }, {
            title: '单位',
            width: 100,
            dataIndex: 'unitName',
        }, {
            title: '海关编码',
            width: 100,
            dataIndex: 'customsCode',
        },
        // {
        //     title: '仓库',
        //     width: 160,
        //     dataIndex: 'warehouse',
        // }, {
        //     title: '货位',
        //     width: 160,
        //     dataIndex: 'shelf',
        // }
    ];

    const action = <>
        {/* <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => { }}
        >导出</Button> */}


    </>

    const leftChildren = mode === 'edit' ? <>
        <Button
            className="mr-5"
            type="link"
            shape="round"
            onClick={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据进行排序");
                    return;
                }
                let number = "";
                Modal.confirm({
                    title: "请输入排序数字",
                    content: <>
                        <Input placeholder="请输入排序数字" onChange={(e) => { number = e.target.value }} />
                    </>,
                    okText: '确定',
                    cancelText: '取消',
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            if (number && /^[+-]?\d*\.?\d*$/.test(number)) {
                                resolve(number);
                            } else {
                                message.warning("请输入排序数字");
                                reject('请输入排序数字');
                            }
                        }).then(async (res: any) => {
                            let { retData } = await enquiryService.shipmentOrderNum({
                                id: selectedRowKeys[0],
                                orderNum: +res
                            })
                            message.success("修改成功")
                        });
                    },
                    onCancel: () => { }
                })
            }}
        >修改顺位</Button>
    </> : <></>
    //商品合计，变动时  修改主单金额
    const getTotalRow = (tableList: IShipmentMaterial[]): IShipmentMaterial => {
        let num: number = 0,
            grossWeight: number = 0,
            netWeight: number = 0,
            amount: number = 0;

        tableList.forEach(item => {
            num += +item.num;
            amount += +item.amount;
            grossWeight += +(item.grossWeight ?? 0);
            netWeight += +(item.netWeight ?? 0);
        });

        return {
            key: "totalAmount",
            totalTxt: "合计:",
            num, grossWeight: formatNum(grossWeight), netWeight: formatNum(netWeight),
            amount: formatNum(amount),
            price: "null",
        }
    }

    const newColumn = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑
                editable: record.key === "totalAmount" ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: any) => {
        row.netWeight = formatNum(row.netWeight);
        row.grossWeight = formatNum(row.grossWeight);

        let dataSource = [...editList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        updateList(dataSource);
    }

    return (
        <YhBox title={leftChildren} style={{ marginBottom: "75px" }} rightChildren={action}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: any[]) => {
                        setSelectedRowKeys(selectedRowKeys.filter(item => item !== "totalAmount") as string[]);
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumn as ColumnsType<any>}
                dataSource={editList.length > 0 ? [...editList, getTotalRow(editList)] : []}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}